import React from "react";
import Bubble from "../../../../components/Bubble/Bubble";

const HelpMeToSelectActivitiesBubbleContent = ({
  setShowSelectActivityModal,
  handleHelMeToSelectActivities,
  stepPrompt,
  currentFormatedTime,
}) => {
  return (
    <Bubble
      isDisabled={stepPrompt.current > 2}
      message={{ type: "ai" }}
      manualFormatedTime={currentFormatedTime || null}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
          <div>
            Ahora que estamos alineados, utilizaremos esos objetivos de
            aprendizaje para guiar la planeación de tu sesión 🎉.
          </div>
          <div>
            Es momento de seleccionar las actividades, ¿ya sabes qué actividades
            ENAd integrarás en tu planeación o prefieres que te ayude a
            seleccionarlas?
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex gap-4 flex-col">
              <div className="flex flex-col">
                <div
                  className="flex justify-between bg-shaiaBlue text-DarkBlue-500 py-2 px-4 cursor-pointer rounded-md"
                  onClick={() => setShowSelectActivityModal(true)}
                >
                  <div className="font-bold">
                    Ya sé que actividades ENAd quiero integrar
                  </div>
                </div>
              </div>
              <div className="flex flex-col">
                <div
                  className="flex justify-between bg-Yellow-500 text-DarkBlue-500 py-2 px-4 cursor-pointer rounded-md"
                  onClick={() => handleHelMeToSelectActivities()}
                >
                  <div className="font-bold">
                    Ayúdame a seleccionar las actividades ENAd
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Bubble>
  );
};

export default HelpMeToSelectActivitiesBubbleContent;
